export default "Base footer template";